import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { IAnnotation, IAnnotationInput } from '@ebb-v2/ebb-integration';

import { Apollo } from 'apollo-angular';
import { GetAnnotationByIdQuery, SaveAnnotationMutation, DeleteAnnotationMutation } from '@ebb-v2/ebb-integration';

@Injectable({
    providedIn: 'root'
  })
export class AnnotationApiService  {
  
  constructor(
    private apollo: Apollo
  ) { }
  
  public getAnnotation(id: string): Observable<IAnnotation> {
    return this.apollo
      .watchQuery({
        query: GetAnnotationByIdQuery,
        variables: {
            id: id,
        }
      })
      .valueChanges
      .pipe(map(result => result.data['annotation'] as IAnnotation), take(1));   
  }

  public saveAnnotation(annotationInput: IAnnotationInput) : Observable<IAnnotation> {
    return this.apollo
      .mutate({
        mutation: SaveAnnotationMutation,
        variables : {
          annotationInput
        }
      })
      .pipe(map(result => result.data['saveAnnotation'] as IAnnotation));
  }

  public deleteAnnotation(annotationId: string,applicationId:string) : Observable<any> {
    //console.log(`AnnotationApi.delete()`);
    return this.apollo
      .mutate({
        mutation: DeleteAnnotationMutation,
        variables : {
          annotationId: annotationId,
          applicationId:applicationId
        }
      })
      .pipe(map(result => result.data['deleteAnnotation'] as any));
  }

}